import {
  HTTP_GETFORECASTLIST1_FETCHING,
  HTTP_GETFORECASTLIST1_SUCCESS,
  HTTP_GETFORECASTLIST1_FAILED,
  HTTP_RESET_FORECASTLIST1,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETFORECASTLIST1_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETFORECASTLIST1_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETFORECASTLIST1_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    case HTTP_RESET_FORECASTLIST1:
      return initialState;
    default:
      return state;
  }
};
